package com.eladfinish.bible.contest.screens.mikud.usecases

import com.eladfinish.bible.contest.constants.StringConstants.CHAPTER_NUMBER_REGEX

class GetChaptersInMikudUseCase {

    operator fun invoke(mikudStr: String, bookNumber: Int): List<Pair<Int, String>> {
        val filenames = mutableListOf<Pair<Int, String>>()
        val line = mikudStr.split("\n").firstOrNull { it.contains("#$bookNumber") } ?: return emptyList()
        val numberAndBookName = line.substring(1, line.indexOf("-") + 1)
        CHAPTER_NUMBER_REGEX.toRegex().findAll(line).forEach {
            val group = it.groupValues[1]
            filenames.add(group.toInt() to "_$numberAndBookName$group.txt")
        }
        return filenames
    }
}
